import { DocumentKind } from "client/Api/Documents/SharePoint/common";

export function getDocumentKind(extension: string): DocumentKind | undefined {
	switch (extension.toLowerCase()) {
		case ".docx":
		case ".docm":
		case ".dotx":
		case ".dotm":
		case ".doc":
			return DocumentKind.Word;
		case ".xlsx":
		case ".xlsm":
		case ".xls":
			return DocumentKind.Excel;
		case ".potx":
		case ".pptx":
		case ".ppt":
		case ".pptm":
			return DocumentKind.PowerPoint;
		case ".vsdx":
		case ".vsd":
			return DocumentKind.Visio;
		default:
			return undefined;
	}
}